import {deleteCategoryApi} from "../../api/entities/categories";
import {createDeleteSlice} from "../genericCrudSlice";

const deleteCategorySlice = createDeleteSlice('delete', deleteCategoryApi);
export const {init} = deleteCategorySlice.actions;
export const {deleteEntity: deleteCategory} = deleteCategorySlice;
export default deleteCategorySlice.reducer;